import React, {Component} from "react";
import CmModal from "../../../../../components/CmModal/CmModal";
import CmForm from "../../../../../components/CmForm/CmForm";
import {Form, Input, InputNumber} from "antd";
import PermissionTreeSelect from "../permissionTreeSelect/PermissionTreeSelect";
import {validateName} from "../../../../../utils";
import {message} from "../../../utils/sysManagementUtils";

const FormItem = Form.Item;
export default class PermissionEditModal extends Component {
    constructor(props) {
        super(props);
        this.state = {
            editData: null
        };
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (this.props.visible&&this.props.visible !== prevProps.visible) {
            this.setState({
                editData: initData(this.props.data || {})
            });
        }
    }

    render() {
        const {
            visible
        } = this.props;

        const {editData} = this.state;

        if (!editData) {
            return null;
        }

        const isCreate = !editData.id.value;
        const onDataChange = this.onDataChange;

        return (
            <CmModal
                title={isCreate ? "添加权限" : "修改权限"}
                visible={visible}
                handleCancel={this.handleCancel}
                handleOk={this.handleOk}
                destroyOnClose={true}
            >
                <CmForm>
                    <FormItem
                        required={editData.name.required}
                        label={editData.name.label}
                    >
                        <Input
                            placeholder={editData.name.placeholder}
                            value={editData.name.value}
                            onChange={e => onDataChange({name: e.target.value})}
                        />
                    </FormItem>
                    <FormItem
                        required={editData.code.required}
                        label={editData.code.label}
                    >
                        <Input
                            placeholder={editData.code.placeholder}
                            value={editData.code.value}
                            onChange={e => onDataChange({code: e.target.value})}
                            disabled={!isCreate}
                        />
                    </FormItem>

                    <FormItem
                        required={editData.permissionClassifyTreeId.required}
                        label={editData.permissionClassifyTreeId.label}
                    >
                        <PermissionTreeSelect
                            value={editData.permissionClassifyTreeId.value}
                            placeholder={editData.permissionClassifyTreeId.placeholder}
                            checkStrictly={true}
                            handleOk={permissionClassifyTreeId => onDataChange({permissionClassifyTreeId})}
                            onItemDelete={id => onDataChange({permissionClassifyTreeId: ""})}
                        />
                    </FormItem>

                    <FormItem
                        required={editData.permissionSort.required}
                        label={editData.permissionSort.label}
                    >
                        <InputNumber
                            placeholder={editData.permissionSort.placeholder}
                            value={editData.permissionSort.value || 0}
                            min={0}
                            onChange={permissionSort => onDataChange({permissionSort})}
                        />
                    </FormItem>
                    <FormItem
                        required={editData.remark.required}
                        label={editData.remark.label}
                    >
                        <Input.TextArea
                            placeholder={editData.remark.placeholder}
                            rows={4} value={editData.remark.value}
                            onChange={e => onDataChange({remark: e.target.value})}
                            onKeyDown={e => e.stopPropagation()}
                        />
                    </FormItem>
                </CmForm>
            </CmModal>
        );
    }

    onDataChange = data => {
        const editData = this.state.editData;
        Object.keys(data).forEach(key => {
            editData[key].value = data[key];
        });
        this.setState({});
    };

    handleOk = () => {
        const {editData} = this.state;
        const data = {};
        const editDataKeys = Object.keys(editData);
        for (let i = 0; i < editDataKeys.length; i++) {
            const key = editDataKeys[i];
            data[key] = editData[key].value;
            if (editData[key].check && !editData[key].check(editData[key].value)) {
                return;
            }
        }
        this.props.handleOk(data);
    };

    handleCancel = () => {
        this.props.handleCancel();
    };
}


function initData(
    {
        id = "",
        name = "",
        code = "",
        remark = "",
        permissionSort = 10,
        permissionClassifyTreeId = ""
    } = {}
) {
    return {
        id: {
            value: id
        },
        name: {
            label: "权限名称",
            value: name,
            required: true,
            placeholder: "请输入权限名称",
            check: value => {
                if (!value) {
                    message.error("权限名称不能为空！");
                    return false;
                }
                if (!validateName(value, {min: 1, max: 50})) {
                    message.error("权限名称最多50个字符，可使用中文、数字、字母、下划线！");
                    return false;
                }
                return true;
            }
        },
        code: {
            label: "权限编码",
            value: code,
            required: true,
            placeholder: "请输入权限编码",
            check: value => {
                if (!value) {
                    message.error("编码不能为空！");
                    return false;
                }
                if (!(/^[0-9a-zA-Z:_]{1,100}$/.test(value))) {
                    message.error("权限编码只可填写字母、数字、下划线及冒号，限制输入100个字符！");
                    return false;
                }
                return true;
            }
        },
        remark: {
            label: "权限描述",
            value: remark,
            placeholder: "请输入描述信息",
            required: false
        },
        permissionClassifyTreeId: {
            label: "权限分类",
            value: permissionClassifyTreeId,
            placeholder: "请选择权限分类",
            required: true,
            check: value => {
                let check = true;
                if (!value) {
                    message.error("请选择权限分类！");
                    check = false;
                }
                return check;
            }
        },
        permissionSort: {
            label: "排序",
            placeholder: "排序",
            value: permissionSort,
            required: false,
            check: value => {
                value = value ? value + "" : 0;

                if (value.length) {
                    if (!/^\d+$/.test(value)) {
                        message.error("排序只能输入自然数！");
                        return false;
                    }
                    if (parseInt(value, 10) > 9999) {
                        message.error("排序最大为9999！");
                        return false;
                    }
                }
                return true;
            }
        }
    };
};

